import { Box, Flex, type FlexProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/** Inset desktop panel shared by auth and the first onboarding steps. */
export const OnboardingPanelFrame = ({
  children,
  bg,
}: {
  children: ReactNode;
  bg: FlexProps['bg'];
}) => (
  <Box flex="0 0 46%" maxW="620px" display={{ base: 'none', lg: 'flex' }} py="12px" pr="12px">
    <Flex
      direction="column"
      flex="1"
      gap="24px"
      borderRadius="24px"
      bg={bg}
      px="48px"
      py="40px"
      overflowY="auto"
      transition="background-color .3s"
    >
      {children}
    </Flex>
  </Box>
);
